import { useEffect, useState } from 'react';
import { getZonedParts } from '../utils/zonedTime';

const HOUR_CHECK_INTERVAL_MS = 1000;

function readZonedHour(timeZone: string): number {
    return getZonedParts(new Date(), timeZone).hour;
}

/**
 * 球場當地目前的整點小時。營業狀態只依整點判斷，狀態只在跨過整點時才改變，
 * 所以使用的頁面不會因為這個檢查每秒重新渲染。
 */
export function useZonedHour(timeZone: string): number {
    const [zonedHour, setZonedHour] = useState(() => readZonedHour(timeZone));

    useEffect(() => {
        const updateZonedHour = () => setZonedHour(readZonedHour(timeZone));
        updateZonedHour();
        const intervalId = setInterval(updateZonedHour, HOUR_CHECK_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [timeZone]);

    return zonedHour;
}
